import axios from '@/utils/axios'
import queryString from '@/utils/queryString';
import customerSearch from './customerSearch';

export default {
    namespaced: true,
    modules: {
        search: customerSearch
    },
    state: {
        customer: null,
        customers: [],
        customerSearch: [],
        statement: null,
        customerSalesOrders: null
    },
    mutations: {
        setCustomer(state, payload) {
            state.customer = payload;
        },
        setCustomers(state, payload) {
            state.customers = payload;
        },
        setCustomersConcat(state, payload) {
          state.customerSearch = [...state.customerSearch, ...payload];  
        },
        setResetCustomers(state) {
            state.customers = []
        },
        setResetCustomer(state) {
            state.customer = null;
        },
        setStatement(state, payload) {
            state.statement = payload;
        },
        setCustomerOrdersLines(state, payload) {
            state.customerSalesOrders = payload;
        },
        resetStatement(state) {
            state.statement = null;
        }
    },
    actions: {
        storeCustomer({rootState, dispatch}, payload) {
            const headers = {
                Authorization: `Bearer ${rootState.authentication.token}`,
                Dpk: payload.dpk
            }
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url:`${rootState.sales.routePrefix}/customers`,
                    data: payload,
                    headers: headers
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        updateCustomer({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.sales.routePrefix}/customers/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removeCustomer({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.sales.routePrefix}/customers/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removeCustomers({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.sales.routePrefix}/customers`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        fetchCustomer({ commit, rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/customers/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setCustomer', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                });
            })
        },
        fetchCustomers({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/customers?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setCustomers', response.data.data);
                    commit('setCustomersConcat', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        resetCustomers({commit}) {
            commit('setResetCustomers');
        },
        resetCustomer({commit}) {
            commit('setResetCustomer');
        },
        setCustomers({commit}, payload) {
            commit('setCustomersConcat', payload);
        },
        fetchCustomerStatement({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/customers/${payload.customer_id}/statement?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                   
                })
                .then((response) => {
                    resolve(response);
                    commit('setStatement', response.data)
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        fetchCustomerSalesOrdersLines({ commit, rootState, dispatch }, payload) {
           
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/customers/${payload.customer_id}/sales-order-item-lines`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                    commit('setCustomerOrdersLines', response.data)
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        fetchCustomerInvoicesLines({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/customers/${payload.customer_id}/invoices-lines`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        resetStatement({commit}){
            commit('resetStatement');
        },
        setCustomersFromSearch({commit}, payload) {
            commit("setCustomersConcat", payload);
        }

    }
}